const PROGRESS_CURRENCY_LABELS: Record<string, string> = {
  JPY: '円',
  USD: 'ドル',
};

const PROGRESS_UNIT_LABELS: Record<string, string> = {
  K: '千',
  M: '百万',
  B: '十億',
  T: '兆',
};

export const formatProgressTableHeader = (
  metricLabel: string,
  currency: string | null | undefined,
  unit?: string | null,
): string => {
  const currencyLabel = typeof currency === 'string'
    ? PROGRESS_CURRENCY_LABELS[currency.trim().toUpperCase()]
    : undefined;
  const normalizedUnit = typeof unit === 'string' ? unit.trim().toUpperCase() : '';
  const unitLabel = PROGRESS_UNIT_LABELS[normalizedUnit || 'M'];

  return `${metricLabel}推移${unitLabel && currencyLabel ? `(${unitLabel}${currencyLabel})` : ''}`;
};